export function formatDateUS(dateString) {
    const date = new Date(dateString);
    if (isNaN(date)) return '-';

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}


export function unmarshallDynamoDBItem(item) {
    if (!item || typeof item !== "object") return item;

    const result = {};
    for (const key in item) {
        const valueObj = item[key];

        if (typeof valueObj === "object" && valueObj !== null) {
            const valueType = Object.keys(valueObj)[0]; // "S", "N", "BOOL", "L", "M"
            const value = valueObj[valueType];

            if (valueType === "M") {
                result[key] = unmarshallDynamoDBItem(value); // recursive unmarshal
            } else if (valueType === "L") {
                result[key] = value.map(unmarshallDynamoDBItem); // list of items
            } else {
                result[key] = value; // simple type
            }
        } else {
            result[key] = valueObj; // already plain
        }
    }

    // Rename title → name for compatibility with JSX
    if (result.title) {
        result.name = result.title;
    }

    // Ensure features is always an array of strings
    if (result.features && Array.isArray(result.features)) {
        result.features = result.features.map(f => (typeof f === "object" && f.S ? f.S : f));
    } else {
        result.features = [];
    }

    return result;
}

